import React from 'react';
import type { MetricCardType } from '../../../const';
import { BaseCard, type BaseCardData } from './BaseCard';

export type MetricCardData = BaseCardData & {
  value: string | number | { minutes: number; seconds: number };
  unit?: string | { minute: string; seconds: string };
  type: MetricCardType;
  seriesData?: Array<{
    bucket: string;
    value: string;
    conversationNumber?: number | null;
    metricType?: string;
  }>;
  scale?: string | null;
};

type AnalyticsCardProps = {
  item: MetricCardData;
  onClick?: (item: MetricCardData) => void;
  onChartClick?: (item: MetricCardData) => void;
};

export const AnalyticsCard: React.FC<AnalyticsCardProps> = ({
  item,
  onClick,
  onChartClick,
}) => {
  return (
    <BaseCard<MetricCardData>
      item={item}
      onClick={onClick}
      showChartButton={!!(item.seriesData && item.seriesData.length > 0)}
      onChartClick={onChartClick}
      className="w-full h-full flex flex-col bg-white rounded-card cursor-pointer p-3 xl:p-4 shadow-sm hover:shadow-md transition-all duration-200 focus:outline-none focus-visible:outline-none"
      contentClassName="flex flex-col justify-end flex-1"
    >
      <div className="flex items-baseline gap-1">
        {typeof item.value === 'object' && 'minutes' in item.value ? (
          <div className="flex items-baseline gap-1">
            <span className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-semibold text-mainText">
              {item.value.minutes}
            </span>
            {typeof item.unit === 'object' && 'minute' in item.unit && (
              <span className="text-xs sm:text-tiny lg:text-small xl:text-small text-secondary">
                {item.unit.minute}
              </span>
            )}
            <span className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-semibold text-mainText">
              {item.value.seconds}
            </span>
            {typeof item.unit === 'object' && 'seconds' in item.unit && (
              <span className="text-xs sm:text-tiny lg:text-small xl:text-small text-secondary">
                {item.unit.seconds}
              </span>
            )}
          </div>
        ) : (
          <>
            <span className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-semibold text-mainText">
              {item.value}
            </span>
            {item.unit && typeof item.unit === 'string' && (
              <span className="text-xs sm:text-tiny lg:text-small xl:text-small text-secondary">
                {item.unit}
              </span>
            )}
          </>
        )}
      </div>
    </BaseCard>
  );
};
